// Provider-specific labels for the DNS record fields. These strings mirror the
// EXACT wording each provider's (English) DNS UI uses, so they aren't
// translated — they're what the seller literally sees in that dashboard. The
// backend detects the provider key from the domain's nameservers.
export type DomainProviderInfo = {
  name: string;
  /** What the provider calls the record "Name" field. */
  nameField: string;
  /** What the provider calls the record "Value"/"Target" field. */
  valueField: string;
  /** Public help article for adding a CNAME record. */
  helpUrl: string;
};

export const DOMAIN_PROVIDERS: Record<string, DomainProviderInfo> = {
  godaddy: {
    name: "GoDaddy",
    nameField: "Host",
    valueField: "Points to",
    helpUrl: "https://www.godaddy.com/help/add-a-cname-record-19236",
  },
  namecheap: {
    name: "Namecheap",
    nameField: "Host",
    valueField: "Value",
    helpUrl:
      "https://www.namecheap.com/support/knowledgebase/article.aspx/9646/2237/how-to-create-a-cname-record-for-your-domain/",
  },
  cloudflare: {
    name: "Cloudflare",
    nameField: "Name",
    valueField: "Target",
    helpUrl:
      "https://developers.cloudflare.com/dns/manage-dns-records/how-to/create-dns-records/",
  },
  route53: {
    name: "Amazon Route 53",
    nameField: "Record name",
    valueField: "Value",
    helpUrl:
      "https://docs.aws.amazon.com/Route53/latest/DeveloperGuide/resource-record-sets-creating.html",
  },
  google: {
    name: "Google Domains / Squarespace",
    nameField: "Host name",
    valueField: "Data",
    helpUrl: "https://support.google.com/domains/answer/3290350",
  },
  hostinger: {
    name: "Hostinger",
    nameField: "Name",
    valueField: "Target",
    helpUrl:
      "https://support.hostinger.com/en/articles/1583227-how-to-add-a-cname-record",
  },
  ionos: {
    name: "IONOS",
    nameField: "Host name",
    valueField: "Points to",
    helpUrl: "https://www.ionos.com/help/domains/configuring-cname-records/",
  },
  namecom: {
    name: "Name.com",
    nameField: "Host",
    valueField: "Answer",
    helpUrl:
      "https://www.name.com/support/articles/115004972547-adding-a-cname-record",
  },
  hover: {
    name: "Hover",
    nameField: "Hostname",
    valueField: "Target Host",
    helpUrl:
      "https://help.hover.com/hc/en-us/articles/217282457-Managing-DNS-records",
  },
  dnsimple: {
    name: "DNSimple",
    nameField: "Name",
    valueField: "Content",
    helpUrl: "https://support.dnsimple.com/articles/cname-record/",
  },
  digitalocean: {
    name: "DigitalOcean",
    nameField: "Hostname",
    valueField: "Is an alias of",
    helpUrl:
      "https://docs.digitalocean.com/products/networking/dns/how-to/manage-records/",
  },
  azure: {
    name: "Azure DNS",
    nameField: "Name",
    valueField: "Alias",
    helpUrl:
      "https://learn.microsoft.com/azure/dns/dns-operations-recordsets-portal",
  },
};

export function getDomainProvider(
  key: string | null | undefined,
): DomainProviderInfo | null {
  if (!key) {
    return null;
  }
  return DOMAIN_PROVIDERS[key] ?? null;
}
